export default {
  // Hero
  'hero.badge': '联系我们',
  'hero.title': '来聊聊你的包装需求',
  'hero.subtitle':
    '从单个现货容器到完全定制的项目，我们的采购团队随时为你答疑并给出报价。',

  // Quick Contact
  'quick.label': '取得联系',
  'quick.title': '我们响应迅速',
  'quick.subtitle':
    '直接联系我们，或在下方留言，我们的团队会在一个工作日内回复你。',
  'quick.email.label': '发送邮件',
  'quick.email.desc': '咨询、报价与合作',
  'quick.phone.label': '致电我们',
  'quick.phone.desc': '周一至周五，09:00–18:00（KST / CST）',
  'quick.response.label': '响应时间',
  'quick.response.value': '1 个工作日内',
  'quick.response.desc': '每个区域都有专属客户经理',

  // Locations
  'locations.label': '我们的办公地点',
  'locations.title': '三处办公地，一个全球网络',
  'locations.subtitle':
    '总部位于首尔，并在中国主要制造枢纽设有分公司，让我们既贴近客户，也贴近工厂。',
  'locations.hq.badge': '总部',
  'locations.branch.badge': '分公司',
  'locations.hq.name': '首尔 — 圣水洞',
  'locations.hq.address': '韩国首尔特别市城东区圣水洞',
  'locations.hq.note': '全球采购与客户成功',
  'locations.b1.badge': '中国分公司 1',
  'locations.b1.name': '上海 — 闵行',
  'locations.b1.address': '中国上海市闵行区',
  'locations.b1.note': '华东采购与质检',
  'locations.b2.badge': '中国分公司 2',
  'locations.b2.name': '广州 — 白云',
  'locations.b2.address': '中国广州市白云区',
  'locations.b2.note': '华南采购与物流',

  // Form
  'form.label': '发送留言',
  'form.title': '告诉我们你的需求',
  'form.subtitle': '填写表单，我们的团队将回复报价、样品或下一步安排。',
  'form.name': '姓名',
  'form.name.placeholder': '你的姓名',
  'form.email': '工作邮箱',
  'form.email.placeholder': 'you@company.com',
  'form.company': '公司',
  'form.company.placeholder': '你的公司名称',
  'form.country': '国家 / 地区',
  'form.country.placeholder': '选择你的国家',
  'form.type': '咨询类型',
  'form.type.general': '一般咨询',
  'form.type.quote': '申请报价',
  'form.type.sample': '样品申请',
  'form.type.partnership': '供应商合作',
  'form.type.other': '其他',
  'form.message': '留言内容',
  'form.message.placeholder': '告诉我们你设想的产品、数量、后加工或时间安排…',
  'form.submit': '发送留言',
  'form.sending': '发送中…',
  'form.success.title': '留言已发送！',
  'form.success.desc': '感谢你的来信，我们的团队会在一个工作日内回复你。',
  'form.error.title': '出了点问题',
  'form.error.retry': '请重试。',
};